import { useMsal } from "@azure/msal-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { baseURL } from "../Constant";
import { resetSubmissionButton } from "../Redux/Mailer";
import "./Container.css";
import DisplayedScreen from "./DisplayedScreen";
import LeftContainer from "./LeftContainer";
import { leftContainerParams } from "../../sensitiveMedia/data";


const Container = ({ allReset, setAllReset }) => {
    const [mediaUrls, setMediaUrls] = useState({});
    const query = `params=${encodeURIComponent(JSON.stringify(leftContainerParams))}`;
 const [categoryName, setCategoryName] = useState("Program");
 const [mailerParent, setMailerParent] = useState(null);
 const [mailerChild, setMailerChild] = useState(null);
 const [isMailGenerated, setIsMailGenerated] = useState(null);
 const [modalResponse, setModalResponse] = useState("");
 const [isLoading, setIsloading] = React.useState(false);
 const [text, setText] = useState(null);

 const [programName, setProgramName] = useState("");
 const [launchDate, setLaunchDate] = useState();
 const [keyPoints, setKeyPoints] = useState("");
 const [additionalInfo, setAdditionalInfo] = useState("");

 const [targAudience, setTargAudience] = useState("");
 const [introduction, setIntroduction] = useState("");
 const [callToAction, setCallToAction] = useState("");
 const [contactInfo, setContactInfo] = useState("");
 const [additionalResources, setAdditionalResources] = useState("");
 const [personalizedMsg, setPersonalizedMsg] = useState("");
 const [additionalNotes, setAdditionalNotes] = useState("");
 const [launchCampaignVal, setLaunchCampaignVal] = useState(null);
 const [campaignItem, setCampaignItem] = useState(0);

 const [navigatedToForm, setNavigatedToForm] = useState(false);
 const dispatch = useDispatch();
 const [open, setOpen] = useState(false);
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const [userID, setUserID] = useState(null);

 //  Teaser States
 const [categoryNameTeaser, setCategoryNameTeaser] = useState("Program");

 //Follow-Up/Reminder States
 const [categoryNameReminder, setCategoryNameReminder] = useState("Program");
 const [categoryNameNudge, setCategoryNameNudge] = useState("Program");
 const [categoryNameRecognition, setCategoryNameRecognition] = useState("Program");
 const [categoryNameClosure, setCategoryNameClosure] = useState("Program");

 //Approver screen
 const [activeScreen, setActiveScreen] = useState("default");

 useEffect(()=>{
  
      const fetchMediaUrls = async () => {
        try {
          const response = await axios.get(`${baseURL}/media?${query}`)
          setMediaUrls(response.data); 
        } catch (error) {
          console.error('Error fetching image URLs:', error);
        }
      };
    
      fetchMediaUrls();
  
 },[]);

 useEffect(() => {
  if (activeAccount) {
   setUserID(activeAccount.idTokenClaims.enterpriseID);
  }
 }, [activeAccount]);
 function handleRegeneration(userquery) {
  console.log("");
  setIsloading(true);

  let values = {
   programName: programName,
   launchDate: launchDate,
   contactInfo: contactInfo,
   targAudience: targAudience,
   keyPoints: keyPoints,
   additionalResources: additionalResources,
   callToAction: callToAction,
   personalizedMsg: personalizedMsg,
   additionalNotes: additionalNotes,
   additionalInfo: additionalInfo,

   currentContent: text,
   userquery: userquery,
   sessionID: localStorage.getItem("sessionId"),
   username: userID,
  };
  axios
   .post(`${baseURL}/fetchresponse`, { values })
   .then((response) => {
    setModalResponse(response.data);
    setIsloading(false);
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail", err);
    setIsloading(false);
   });
 }

 function handleGenerate() {
  setIsloading(true);
  setIsMailGenerated("generateOutput");
  let values = {
   programName: programName,
   launchDate: launchDate,
   contactInfo: contactInfo,
   targAudience: targAudience,
   keyPoints: keyPoints,
   additionalResources: additionalResources,
   callToAction: callToAction,
   personalizedMsg: personalizedMsg,
   additionalNotes: additionalNotes,
   additionalInfo: additionalInfo,
   introduction: introduction,
   currentContent: "",
   sessionID: localStorage.getItem("sessionId"),
   username: userID,
   categoryName: categoryName,
  };
  axios
   .post(`${baseURL}/fetchresponse`, { values })
   .then((response) => {
    // then print response status
    setModalResponse(response.data);
    setIsloading(false);
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail", err);
    setIsloading(false);
   });
 }

 const handleReset = () => {
  setProgramName("");
  setPersonalizedMsg("");
  setIntroduction("");
  setKeyPoints("");
  setAdditionalNotes("");
  setAdditionalResources("");
  setCallToAction("");
  setContactInfo("");
  setLaunchDate("");
  setTargAudience("");
  setModalResponse("");
  setMailerChild("");
  setMailerParent("");
  setCategoryName("Program");
  setIsMailGenerated("");
  setAdditionalInfo("");
  dispatch(resetSubmissionButton());
  setCampaignItem(0);
  setLaunchCampaignVal(null);
  setNavigatedToForm(false);
 };

 const handleClickOpen = () => {
  setOpen(true);
 };

 useEffect(() => {
  setMailerChild(null);
  setMailerParent(null);
 }, [allReset]);
 return (
  <>
   {/* <div className="main-banner" id="main">
    <img
     src={process.env.PUBLIC_URL + "/Images/banner.jpg"}
     alt="banner"
     className="banner-img"
    />
   </div> */}
   <div className="comms-container">
    <LeftContainer
     mailerParent={mailerParent}
     mailerChild={mailerChild}
     setMailerParent={setMailerParent}
     setMailerChild={setMailerChild}
     categoryName={categoryName}
     setCategoryName={setCategoryName}
    />
    {/* <MailForm
          mailerParent={mailerParent}
          mailerChild={mailerChild}
          setMailerParent={setMailerParent}
          setMailerChild={setMailerChild}
        /> */}
    <DisplayedScreen
     mailerChild={mailerChild}
     mailerParent={mailerParent}
     isMailGenerated={isMailGenerated}
     setIsMailGenerated={setIsMailGenerated}
     modalResponse={modalResponse}
     setModalResponse={setModalResponse}
     isLoading={isLoading}
     setIsLoading={setIsloading}
     text={text}
     setText={setText}
     handleRegeneration={handleRegeneration}
     programName={programName}
     setProgramName={setProgramName}
     launchDate={launchDate}
     setLaunchDate={setLaunchDate}
     keyPoints={keyPoints}
     setKeyPoints={setKeyPoints}
     targAudience={targAudience}
     setTargAudience={setTargAudience}
     callToAction={callToAction}
     setCallToAction={setCallToAction}
     contactInfo={contactInfo}
     setContactInfo={setContactInfo}
     additionalResources={additionalResources}
     setAdditionalNotes={setAdditionalNotes}
     personalizedMsg={personalizedMsg}
     setPersonalizedMsg={setPersonalizedMsg}
     additionalNotes={additionalNotes}
     setAdditionalResources={setAdditionalResources}
     handleReset={handleReset}
     handleClickOpen={handleClickOpen}
     open={open}
     setOpen={setOpen}
     handleGenerate={handleGenerate}
     navigatedToForm={navigatedToForm}
     setNavigatedToForm={setNavigatedToForm}
     introduction={introduction}
     setIntroduction={setIntroduction}
     categoryName={categoryName}
     setCategoryName={setCategoryName}
     setAdditionalInfo={setAdditionalInfo}
     additionalInfo={additionalInfo}
     categoryNameTeaser={categoryNameTeaser}
     setCategoryNameTeaser={setCategoryNameTeaser}
     setMailerParent={setMailerParent}
     setMailerChild={setMailerChild}
     categoryNameReminder={categoryNameReminder}
     setCategoryNameReminder={setCategoryNameReminder}
     categoryNameNudge={categoryNameNudge}
     setCategoryNameNudge={setCategoryNameNudge}
     categoryNameRecognition={categoryNameRecognition}
     setCategoryNameRecognition={setCategoryNameRecognition}
     setCategoryNameClosure={setCategoryNameClosure}
     categoryNameClosure={categoryNameClosure}
     launchCampaignVal={launchCampaignVal}
     setLaunchCampaignVal={setLaunchCampaignVal}
     setCampaignItem={setCampaignItem}
     campaignItem={campaignItem}
     videoUrl= {mediaUrls?.mediaUrl?.demoVideo}
     pdfUrl={mediaUrls?.mediaUrl?.userGuide}
    />
   </div>
  </>
 );
};

export default Container;
